<div id="header" class="mt-xxl">
  @if (activeHeading) {
    <div class="greeting-bar">
      <h1>{{ (activeHeading | translate) }}
      </h1>
    </div>
  }
</div>
